import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './tooltip.scss';
const BLANK_PATH = '_blank';
interface TooltipProps {
    icon?: any;
    tooltipText?: string;
    link?: string;
    handleClick?: () => void;
}

const Tooltip: React.FC<TooltipProps> = ({ icon, tooltipText, link = "", handleClick }) => {
    const location = useLocation();
    const isBlank = link?.includes(BLANK_PATH);
    const isActive = !isBlank && location.pathname?.includes(link);

    return (
        <div className='flex flex-col items-center justify-center w-[68px] pb-[8px] bg-darkcolor-600 relative group cursor-pointer' onClick={handleClick}>
            {isBlank ?
                <div className={`p-[12px] hover:bg-darkcolor-500 rounded-[6px] shadow-none focus:outline-none ${isActive ? 'rounded-[6px] bg-darkcolor-600 tooltip-shadow' : ''}`}>
                    {icon}
                </div> :
                <Link to={link} className={`p-[12px] hover:bg-darkcolor-500 rounded-[6px] shadow-none focus:outline-none  ${isActive ? 'rounded-[6px] bg-darkcolor-600 tooltip-shadow' : ''}`}>
                    {icon}
                </Link>
            }

            <div className='absolute z-999 b-[20%] left-[68px] hidden group-hover:block bg-darkcolor-400 w-auto flex justify-center items-center rounded-[8px] py-[4px] px-[8px] min-w-[50px] whitespace-nowrap'>
                <div className='absolute top-[12px] left-[-3px] origin-center rotate-45 w-0 h-0 border-l-0 border-r-[6px] border-darkcolor-400 border-b-[6px]'></div>
                <div className='text-neutral-25'>{tooltipText}</div>
            </div>
        </div>
    )
};

export default Tooltip;